// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"d7b6df88","513":"6859be0b","703":"c69b51a6","787":"974a6848"}[chunkId] + ".chunk.js";
};